import PropTypes from "prop-types";

export const orgDataPropTypes = PropTypes.shape({
  hasItems: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  noOfChildOrganizations: PropTypes.number.isRequired,
  noOfImmediateChildOrganizations: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  createDate: PropTypes.string.isRequired,
  parentId: PropTypes.number,
  organizationDetails: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
  groupId: PropTypes.string,
  maxEnvironmentsLimit: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
});

export const groupPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
  })
);

export const getFileTypesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    telemetryType: PropTypes.number.isRequired,
    fileType: PropTypes.string.isRequired,
    roleId: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
  })
);

export const getFileTypesWithSelectedPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    telemetryType: PropTypes.number.isRequired,
    fileType: PropTypes.string.isRequired,
    roleId: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    selected: PropTypes.bool,
  })
);

export const resourceVersionDetailPropTypes = PropTypes.shape({
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  purpose: PropTypes.string,
  releaseDate: PropTypes.string,
  releaseNote: PropTypes.string,
});
export const resourceVersionPropTypes = PropTypes.shape({
  active: PropTypes.bool.isRequired,
  author: PropTypes.number.isRequired,
  createdOn: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  parentResourceId: PropTypes.string.isRequired,
  region: PropTypes.string,
  resourceDetail: resourceVersionDetailPropTypes,
  userName: PropTypes.string.isRequired,
  versionNumber: PropTypes.string.isRequired,
});

export const selectedResourcePropTypes = PropTypes.shape({
  active: PropTypes.bool.isRequired,
  author: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  organizationName: PropTypes.string.isRequired,
  resourceTypeId: PropTypes.string.isRequired,
  subscribedCount: PropTypes.number.isRequired,
  url: PropTypes.string,
  ResourceVersions: PropTypes.arrayOf(resourceVersionPropTypes),
});

export const selectedResourceVersionPropTypes = PropTypes.shape({
  resourceVersionId: PropTypes.string,
  resourceVersionName: PropTypes.string,
  resourceVersion: PropTypes.string,
  active: PropTypes.string,
  region: PropTypes.string,
});

export const entraGroupPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    text: PropTypes.string,
  })
);

export const environmentPropTypes = PropTypes.shape({
  createdOn: PropTypes.string.isRequired,
  lastUpdatedOn: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  nodes: PropTypes.array.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  accessUrl: PropTypes.string.isRequired,
  organizationId: PropTypes.number.isRequired,
  storageAccount: PropTypes.string.isRequired,
  container: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  appRegistrationId: PropTypes.string.isRequired,
  supportedDataReceiptTypes: PropTypes.arrayOf(PropTypes.number).isRequired,
  certificates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      environmentId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      commonName: PropTypes.string.isRequired,
      startDateTime: PropTypes.string.isRequired,
      endDateTime: PropTypes.string.isRequired,
      thumbprint: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
    })
  ).isRequired,
});

export const subscriptionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  organizationName: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  subscriptionStart: PropTypes.string.isRequired,
  subscriptionEnd: PropTypes.string.isRequired,
});
